import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse } from "react-bootstrap";
// import { Dropdown } from "react-bootstrap";
import "../../App.css";
import SecureLS from "secure-ls";
import Apiurl from "../../Constant/baseUrl";
import axios from "axios";
const ls = new SecureLS();
class Sidebar extends Component {
  constructor() {
    super();
    this.state = {
      sidebaroptionmenudisplay: "block",
      retailerdivdisplay: "none",
      notificationValue: 100,
    };
    this.getBaseUrl = new Apiurl();
  }
  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach((i) => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector("#sidebar").classList.remove("active");
    Object.keys(this.state).forEach((i) => {
      this.setState({ [i]: false });
    });
    //this.updateerreques();
    const dropdownPaths = [
      { path: "/adminrequestmanage", state: "approval" },
      { path: "/adminreversefund", state: "actions" },
      { path: "/adminbulkrevarsal", state: "registration" },
      { path: "/Bulkregistration", state: "bulkoperation" },
      { path: "/Bulkfilelist", state: "bulkoperation" },
      { path: "/Users", state: "actions" },
      { path: "/inventory-report", state: "actions" },
      { path: "/available-inventory-report", state: "actions" },
      { path: "/Cards", state: "actions" },
      { path: "/cardtopupreport", state: "actions" },
      { path: "/wallettransactionreport", state: "actions" },
      { path: "/adminlist", state: "reports" },
      { path: "/retailerlist", state: "reports" },
      { path: "/card/balance/report", state: "reports" },
      // {path:'/Vendorlist', state: 'reports'},
      { path: "/adminSupport", state: "support" },
      { path: "/createRetailer", state: "reports" },
      { path: "/createDistributor", state: "reports" },
      { path: "/createCard", state: "bulkoperation" },
      { path: "/createBulkCard", state: "bulkoperation" },
      { path: "/createBulkCardHistory", state: "bulkoperation" },
      { path: "/createBulkInventory", state: "registration" },
      // {path:'/createVendor', state: 'registration'},
      { path: "/CardCreationRequest", state: "bulkoperation" },
      { path: "/balanceCheck", state: "registration" },

      { path: "/cardtopupreport", state: "retailerreport" },
      { path: "/wallettransactionreport", state: "retailerreport" },
      { path: "/transactionReport", state: "actions" },
      { path: "/retailerSupport", state: "retailerreport" },

      { path: "/userCards", state: "approval" },
      { path: "/cardInventory", state: "approval" },
      { path: "/vaTransactions", state: "actions" },
      { path: "/distributorpendingforapproval", state: "configs" },
      { path: "/bankaccountmapping", state: "configs" },
      { path: "/transactionmap", state: "configs" },
      { path: "/productmapping", state: "configs" },
      { path: "/lotgenerate", state: "lotManagement" },
      { path: "/fetchlots", state: "lotManagement" },
      { path: "/kitMapping", state: "kitMapping" },
      { path: "/kitmappingdelink", state: "kitMapping" },
      { path: "/lotlist", state: "Inventorylist" },
      { path: "/inventory-report", state: "Inventorylist" },
      // { path: "/dispatchtobranch", state: "lotManagement" },
    ];

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true });
      }
    });
  }

  render() {
    let userType = ls.get("key1").userType;
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="text-center sidebar-brand-wrapper d-flex align-items-center">
          <a href="/" className="sidebar-brand brand-logo">
            <img src={require("../../assets/images/logoM.svg")} alt="logo" />
          </a>
          <a href="/" className="sidebar-brand brand-logo-mini pt-3">
            <img
              style={{ width: 90 }}
              src={require("../../assets/images/logoM.svg")}
              alt="logo"
            />
          </a>
        </div>
        {ls.get("key1").adminAuthorisationDto === undefined ? null : (
          <ul className="nav">
            {/* {console.log("adminauto",ls.get('key1').adminAuthorisationDto==undefined)} */}
            <li
              className={
                this.isPathActive("/dashboard") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/dashboard">
                <img
                  // src={require("../../assets/images/dashboardIcon.png")}
                  src={require("../../assets/images/dashboard-monitor.png")}
                  width="25px"
                  height="25px"
                  alt=""
                />
                <span className="menu-title" style={{ fontSize: 15 }}>
                  Dashboard
                </span>
              </Link>
            </li>
            {userType === "RETAILER" ? (
              <>
                <li
                  className={
                    this.isPathActive("/basic-u")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <div
                    className={
                      this.state.bulkoperation
                        ? "nav-link menu-expanded"
                        : "nav-link"
                    }
                    onClick={() => this.toggleMenuState("bulkoperation")}
                    data-toggle="collapse"
                  >
                    <img
                      src={require("../../assets/images/card_management.png")}
                      alt=""
                    />
                    <span className="menu-title">Card Management</span>
                    <i className="menu-arrow"></i>
                  </div>
                  <Collapse in={this.state.bulkoperation}>
                    <ul className="nav flex-column sub-menu">
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "CREATE_USER_CARDS" ? (
                          <li className="nav-item" key={v}>
                            {" "}
                            <Link
                              className={
                                this.isPathActive("/createCard")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/createCard"
                            >
                              Create User/Card
                            </Link>
                          </li>
                        ) : null;
                      })}
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "ADD_CARDS" ? (
                          <li className="nav-item" key={v}>
                            {" "}
                            <Link
                              className={
                                this.isPathActive("/CardCreationRequest")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/CardCreationRequest"
                            >
                              Add Card to User
                            </Link>
                          </li>
                        ) : null;
                      })}
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "BULK_REGISTRATION" ? (
                          <li className="nav-item">
                            <Link
                              className={
                                this.isPathActive("/createBulkCard")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/createBulkCard"
                            >
                              {/* <i className="mdi mdi-chevron-double-right"></i> */}
                              Create Bulk Card
                            </Link>
                          </li>
                        ) : null;
                      })}
                      {/* {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "BULK_REGISTRATION" ? (
                          <li className="nav-item">
                            <Link
                              className={
                                this.isPathActive("/createBulkCardHistory")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/createBulkCardHistory"
                            >
                              Create Creation History
                            </Link>
                          </li>
                        ) : null;
                      })} */}
                    </ul>
                  </Collapse>
                </li>
              </>
            ) : null}
            {/* {userType === "RETAILER" ? (
              <>
                <li
                  className={
                    this.isPathActive("/basic-u")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <div
                    className={
                      this.state.Inventorylist
                        ? "nav-link menu-expanded"
                        : "nav-link"
                    }
                    onClick={() => this.toggleMenuState("Inventorylist")}
                    data-toggle="collapse"
                  >
                    <img
                      src={require("../../assets/images/cardIcon.png")}
                      alt=""
                    />
                    <span className="menu-title">Inventory List</span>
                    <i className="menu-arrow"></i>
                  </div>
                  <Collapse in={this.state.Inventorylist}>
                    <ul className="nav flex-column sub-menu">
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "CREATE_USER_CARDS" ? (
                          <li className="nav-item" key={v}>
                            {" "}
                            <Link
                              className={
                                this.isPathActive("/inventory-report")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/inventory-report"
                            >
                              {" "}
                              Kit List
                            </Link>
                          </li>
                        ) : null;
                      })}
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "ADD_CARDS" ? (
                          <li className="nav-item" key={v}>
                            {" "}
                            <Link
                              className={
                                this.isPathActive("/lotlist")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/lotlist"
                            >
                              Lot List
                            </Link>
                          </li>
                        ) : null;
                      })}
                    </ul>
                  </Collapse>
                </li>
              </>
            ) : null} */}
            {userType === "ADMIN" || userType === "RETAILER" ? (
              <>
                <li
                  className={
                    this.isPathActive("/basic") ? "nav-item active" : "nav-item"
                  }
                >
                  <div
                    className={
                      this.state.actions ? "nav-link menu-expanded" : "nav-link"
                    }
                    onClick={() => this.toggleMenuState("actions")}
                    data-toggle="collapse"
                  >
                    <img
                      // src={require("../../assets/images/reportIcon.png")}
                      src={require("../../assets/images/reportmangement.png")}
                      width="25px"
                      height="25px"
                      alt=""
                    />
                    <span className="menu-title">Report Management</span>
                    <i className="menu-arrow"></i>
                  </div>
                  <Collapse in={this.state.actions}>
                    <ul className="nav flex-column sub-menu">
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "USER_LIST" ? (
                          <li className="nav-item" key={v}>
                            {" "}
                            <Link
                              className={
                                this.isPathActive("/Users")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/Users"
                            >
                              {" "}
                              Users Report
                            </Link>
                          </li>
                        ) : null;
                      })}
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "USER_LIST" ? (
                          userType === "ADMIN" || userType === "RETAILER" ? (
                            <li className="nav-item" key={v}>
                              {" "}
                              <Link
                                className={
                                  this.isPathActive("/inventory-report")
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                to="/inventory-report"
                              >
                                {" "}
                                Inventory Report
                              </Link>
                            </li>
                          ) : (
                            ""
                          )
                        ) : null;
                      })}
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "USER_LIST" ? (
                          userType === "ADMIN" ? (
                            <li className="nav-item" key={v}>
                              {" "}
                              <Link
                                className={
                                  this.isPathActive(
                                    "/available-inventory-report"
                                  )
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                to="/available-inventory-report"
                              >
                                {" "}
                                Available Inventory Report
                              </Link>
                            </li>
                          ) : (
                            ""
                          )
                        ) : null;
                      })}
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "CARD_LIST" ? (
                          <li className="nav-item" key={v}>
                            {" "}
                            <Link
                              className={
                                this.isPathActive("/Cards")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/Cards"
                            >
                              Cards Report
                            </Link>
                          </li>
                        ) : null;
                      })}

                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "WALLET_REPORTS" ? (
                          <li className="nav-item" key={v}>
                            {" "}
                            <Link
                              className={
                                this.isPathActive("/wallettransactionreport")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/wallettransactionreport"
                            >
                              Wallet Report
                            </Link>
                          </li>
                        ) : null;
                      })}
                      {userType !== "RETAILER" &&
                        ls.get("key1").adminAuthorisationDto.map((v) => {
                          return v.adminAuthorisation === "WALLET_REPORTS" ? (
                            <li className="nav-item" key={v}>
                              {" "}
                              <Link
                                className={
                                  this.isPathActive("/transactionReport")
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                to="/transactionReport"
                              >
                                Transaction Report
                              </Link>
                            </li>
                          ) : null;
                        })}
                      {userType !== "RETAILER" && (
                        <>
                          {" "}
                          <li className="nav-item">
                            <Link
                              className={
                                this.isPathActive("/vaTransactions")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/vaTransactions"
                            >
                              VA Transactions
                            </Link>
                          </li>
                        </>
                      )}
                      {userType !== "RETAILER" &&
                        ls.get("key1").adminAuthorisationDto.map((v) => {
                          return v.adminAuthorisation === "TOP_UP_REPORTS" ? (
                            <>
                              <li className="nav-item" key={v}>
                                {" "}
                                <Link
                                  className={
                                    this.isPathActive("/cardtopupreport")
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  to="/cardtopupreport"
                                >
                                  TopUp Report
                                </Link>
                              </li>
                            </>
                          ) : null;
                        })}
                    </ul>
                  </Collapse>
                </li>
              </>
            ) : null}

            {userType === "ADMIN" ? (
              <>
                {ls.get("key1").adminAuthorisationDto.map((v) => {
                  return v.adminAuthorisation ===
                    ("TOP_UP_REPORTS" ||
                      "WALLET_REPORTS" ||
                      "ADMIN_LIST" ||
                      "RETAILER_LIST" ||
                      "SUPPORT") ? (
                    <li
                      className={
                        this.isPathActive("/basic-ui")
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <div
                        className={
                          this.state.reports
                            ? "nav-link menu-expanded"
                            : "nav-link"
                        }
                        onClick={() => this.toggleMenuState("reports")}
                        data-toggle="collapse"
                      >
                        <img
                          // src={require("../../assets/images/reportIcon.png")}
                          src={require("../../assets/images/user-profile.png")}
                          // width="25px"
                          // height="25px"
                          alt=""
                        />
                        {/* <i className="mdi mdi-folder menu-icon"></i> */}
                        <span className="menu-title">User Management</span>
                        <i className="menu-arrow"></i>
                      </div>
                      <Collapse in={this.state.reports}>
                        <ul className="nav flex-column sub-menu">
                          {/* {ls.get("key1").adminAuthorisationDto.map((v) => {
                            return v.adminAuthorisation ===
                              "CREATE_ADMIN_RETAILER" ? (
                              <li className="nav-item">
                                {" "}
                                <Link
                                  className={
                                    this.isPathActive("/createRetailer")
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  to="/createRetailer"
                                  style={{ padding: "0 0 0 28px" }}
                                >
                                  Create Admin
                                </Link>
                              </li>
                            ) : null;
                          })} */}
                          {/* {ls.get("key1").adminAuthorisationDto.map((v) => {
                            return v.adminAuthorisation ===
                              "CREATE_ADMIN_RETAILER" ? (
                              <li className="nav-item" key={v}>
                                {" "}
                                <Link
                                  className={
                                    this.isPathActive("/createDistributor")
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  to="/createDistributor"
                                  style={{ padding: "0 0 0 28px" }}
                                >
                                  Create Distributor
                                </Link>
                              </li>
                            ) : null;
                          })} */}
                          {ls.get("key1").adminAuthorisationDto.map((v) => {
                            return v.adminAuthorisation === "ADMIN_LIST" ? (
                              <li className="nav-item">
                                {" "}
                                <Link
                                  className={
                                    this.isPathActive("/adminlist")
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  to="/adminlist"
                                >
                                  Admin List
                                </Link>
                              </li>
                            ) : null;
                          })}
                          {ls.get("key1").adminAuthorisationDto.map((v) => {
                            return v.adminAuthorisation === "RETAILER_LIST" ? (
                              <li className="nav-item">
                                {" "}
                                <Link
                                  className={
                                    this.isPathActive("/retailerlist")
                                      ? "nav-link active"
                                      : "nav-link"
                                  }
                                  to="/retailerlist"
                                >
                                  Distributor List
                                </Link>
                              </li>
                            ) : null;
                          })}
                        </ul>
                      </Collapse>
                    </li>
                  ) : null;
                })}
                <li
                  className={
                    this.isPathActive("/basic-ui")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <div
                    className={
                      this.state.configs ? "nav-link menu-expanded" : "nav-link"
                    }
                    onClick={() => this.toggleMenuState("configs")}
                    data-toggle="collapse"
                  >
                    <img
                      src={require("../../assets/images/configuration.png")}
                      // width="25px"
                      // height="25px"
                      alt=""
                    />
                    <span className="menu-title">Configurations</span>
                    <i className="menu-arrow"></i>
                  </div>
                  <Collapse in={this.state.configs}>
                    <ul
                      className="nav flex-column sub-menu"
                      // style={{ listStyle: "none" }}
                    >
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/productmapping")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/productmapping"
                        >
                          Map Products
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/transactionmap")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/transactionmap"
                        >
                          Map Failed Transaction
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/bankaccountmapping")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/bankaccountmapping"
                        >
                          Bank Account Mapping
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/distributorpendingforapproval")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/distributorpendingforapproval"
                        >
                          Pending Distributor
                        </Link>
                      </li>

                      {/* <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/cardLimit")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/cardLimit"
                        >
                          Card Limit
                        </Link>
                      </li> */}
                      {/* <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/pennydroplimit")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/pennydroplimit"
                        >
                          Penny Drop Limit Set
                        </Link>
                      </li> */}
                    </ul>
                  </Collapse>
                </li>
                <li
                  className={
                    this.isPathActive("/basic-ui")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <div
                    className={
                      this.state.lotManagement
                        ? "nav-link menu-expanded"
                        : "nav-link"
                    }
                    onClick={() => this.toggleMenuState("lotManagement")}
                    data-toggle="collapse"
                  >
                    <img
                      src={require("../../assets/images/lotmanagment.png")}
                      // width="25px"
                      // height="25px"
                      alt=""
                    />
                    <span className="menu-title">Lot Management</span>
                    <i className="menu-arrow"></i>
                  </div>
                  <Collapse in={this.state.lotManagement}>
                    <ul className="nav flex-column sub-menu">
                      {/* <li className="nav-item">
                        {" "}
                        <Link
                          className={
                            this.isPathActive("/lotgenerate")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/lotgenerate"
                        >
                          Generate Lot
                        </Link>
                      </li> */}

                      <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/fetchlots")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/fetchlots"
                        >
                          Fetch Lots
                        </Link>
                      </li>
                    </ul>
                  </Collapse>
                </li>
                <li
                  className={
                    this.isPathActive("/basic-ui")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <div
                    className={
                      this.state.kitMapping
                        ? "nav-link menu-expanded"
                        : "nav-link"
                    }
                    onClick={() => this.toggleMenuState("kitMapping")}
                    data-toggle="collapse"
                  >
                    <img
                      src={require("../../assets/images/mapping.png")}
                      alt=""
                    />
                    <span className="menu-title">Kit Mappinng</span>
                    <i className="menu-arrow"></i>
                  </div>
                  <Collapse in={this.state.kitMapping}>
                    <ul className="nav flex-column sub-menu">
                      <li className="nav-item">
                        {" "}
                        <Link
                          className={
                            this.isPathActive("/kitMapping")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/kitmapping"
                        >
                          Map Physical Kit
                        </Link>
                      </li>
                      <li className="nav-item">
                        {" "}
                        <Link
                          className={
                            this.isPathActive("/kitmappingdelink")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/kitmappingdelink"
                        >
                          Remap Physical Kit
                        </Link>
                      </li>

                      {/* <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/fetchlots")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/fetchlots"
                        >
                         ReMapping
                        </Link>
                      </li> */}
                    </ul>
                  </Collapse>
                </li>
                <li
                  className={
                    this.isPathActive("/basic-ui")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <div
                    className={
                      this.state.approval
                        ? "nav-link menu-expanded"
                        : "nav-link"
                    }
                    onClick={() => this.toggleMenuState("approval")}
                    data-toggle="collapse"
                  >
                    <img
                      src={require("../../assets/images/approved.png")}
                      alt=""
                    />
                    {/* <i className="mdi mdi-book-open menu-icon"></i> */}
                    <span className="menu-title">Approval</span>
                    <i className="menu-arrow"></i>
                  </div>
                  <Collapse in={this.state.approval}>
                    <ul className="nav flex-column sub-menu">
                      {ls.get("key1").adminAuthorisationDto.map((v) => {
                        return v.adminAuthorisation === "BULK_REGISTRATION" ? (
                          <li className="nav-item">
                            {" "}
                            <Link
                              className={
                                this.isPathActive("/userCards")
                                  ? "nav-link active"
                                  : "nav-link"
                              }
                              to="/userCards"
                            >
                              <i className="mdi mdi-chevron-double-right"></i>
                              Bulk User Cards
                            </Link>
                          </li>
                        ) : null;
                      })}
                      {/* <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/cardInventory")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/cardInventory"
                        >
                          <i className="mdi mdi-chevron-double-right"></i>Card
                          Inventory
                        </Link>
                      </li> */}

                      {/* <li className="nav-item">
                        <Link
                          className={
                            this.isPathActive("/adminrequestmanage")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          to="/adminrequestmanage"
                        >
                          <i className="mdi mdi-chevron-double-right"></i>Fund
                          Request
                        </Link>
                      </li> */}
                    </ul>
                  </Collapse>
                </li>

                <li
                  className={
                    this.isPathActive("/adminSupport")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <Link className="nav-link" to="/adminSupport">
                    <img
                      src={require("../../assets/images/support.png")}
                      alt=""
                    />
                    <span className="menu-title" style={{ fontSize: 15 }}>
                      Support
                    </span>
                  </Link>
                </li>
              </>
            ) : null}
            {/* {userType === "RETAILER" ? (
              <li
                className={
                  this.isPathActive("/basic-ui")
                    ? "nav-item active"
                    : "nav-item"
                }
              >
                <div
                  className={
                    this.state.registration
                      ? "nav-link menu-expanded"
                      : "nav-link"
                  }
                  onClick={() => this.toggleMenuState("registration")}
                  data-toggle="collapse"
                >
                  <i className="mdi mdi-account-multiple-plus menu-icon"></i>
                  <span className="menu-title">Bulk Operations</span>
                  <i className="menu-arrow"></i>
                </div>
                <Collapse in={this.state.registration}>
                  <ul className="nav flex-column sub-menu">
                    {ls.get("key1").adminAuthorisationDto.map((v) => {
                      return v.adminAuthorisation === "BULK_REGISTRATION" ? (
                        <li className="nav-item">
                          {" "}
                          <Link
                            className={
                              this.isPathActive("/createBulkCard")
                                ? "nav-link active"
                                : "nav-link"
                            }
                            to="/createBulkCard"
                          >
                            <i className="mdi mdi-chevron-double-right"></i>
                            Create Bulk Card
                          </Link>
                        </li>
                      ) : null;
                    })}
                    <li className="nav-item">
                      <Link
                        className={
                          this.isPathActive("/createBulkInventory")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/createBulkInventory"
                      >
                        <i className="mdi mdi-chevron-double-right"></i>
                        Inventory File Upload
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={
                          this.isPathActive("/balanceCheck")
                            ? "nav-link active"
                            : "nav-link"
                        }
                        to="/balanceCheck"
                      >
                        <i className="mdi mdi-chevron-double-right"></i>
                        Balance Check
                      </Link>
                    </li>
                  </ul>
                </Collapse>
              </li>
            ) : null} */}
            {userType === "DISTRIBUTOR" || userType === "RETAILER" ? (
              <>
                <li
                  className={
                    this.isPathActive("/vaaccountdetails")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <Link className="nav-link" to="/vaaccountdetails">
                    <img
                      src={require("../../assets/images/virtual_account.png")}
                      // width="25px"
                      // height="25px"
                      alt=""
                    />
                    <span className="menu-title" style={{ fontSize: 15 }}>
                      Virtual Account
                    </span>
                  </Link>
                </li>
                <li
                  className={
                    this.isPathActive("/retailerSupport")
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  {" "}
                  <Link className="nav-link" to="/retailerSupport">
                    <img
                      src={require("../../assets/images/support.png")}
                      alt=""
                    />
                    <span className="menu-title" style={{ fontSize: 15 }}>
                      Support
                    </span>
                  </Link>
                </li>
              </>
            ) : null}
          </ul>
        )}
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }
  updateerreques = () => {
    var ls = new SecureLS();
    let uuid = ls.get("key1").uuid;
    let jwttoken = ls.get("key1").jwtToken;
    // console.log("ls",ls.get('key1').uuid!=undefined)
    if (ls.get("key1").uuid !== undefined) {
      axios({
        method: "GET",
        url: `${this.getBaseUrl.ApiBAseURL}/api/view/retailer/new/request?uuid=${uuid}&pageSize=1&dataSize=2`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + jwttoken,
          "X-Frame-Options": "sameorigin",
        },
      })
        .then(async (response) => {
          // console.log("view all new reques in sidebar----->", response.data);
          if (response.data.successCode === "API_SUCCESS") {
            if (response.data.extraData.NewRequest.length >= 0) {
              this.setState({
                notificationValue: response.data.extraData.NewRequest.length,
              });
            }
          }
        })
        .catch((error) => {});
    }
  };
  componentDidMount() {
    this.onRouteChanged();

    const body = document.querySelector("body");

    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  }
}

export default withRouter(Sidebar);
